import { uid } from "uid";

const generateUpperBracket = (teamIds, bracketType, bracketLevel) => {
  if (teamIds.length < 4) {
    throw Error("Must have at least 4 teams");
  }

  const bracket = {};
  const games = {};

  const totalRounds = Math.ceil(Math.log2(teamIds.length));
  let seeding = [[1, 2]];

  // Generate initial seeding for each round
  for (let round = 1; round < totalRounds; round++) {
    const nextRound = [];
    const sum = Math.pow(2, round + 1) + 1;

    for (const [high, low] of seeding) {
      nextRound.push([high, sum - high], [sum - low, low]);
    }

    seeding = nextRound;
  }

  // Generate matches round by round
  for (let roundIndex = 0; roundIndex < totalRounds; roundIndex++) {
    const gamesInRound = [];
    const matchCount = Math.pow(2, totalRounds - roundIndex - 1);

    for (let matchIndex = 0; matchIndex < matchCount; matchIndex++) {
      const gameId =
        roundIndex === totalRounds - 1 ? `${bracketLevel}Finals` : uid();

      let team1Id = "TBD";
      let team2Id = "TBD";

      if (roundIndex === 0) {
        team1Id = teamIds[seeding[matchIndex][0] - 1] || "BYE";
        team2Id = teamIds[seeding[matchIndex][1] - 1] || "BYE";

        if (
          team1Id === "Hayes Upper Winner" ||
          team2Id === "Hayes Upper Winner"
        ) {
          games["hayesUpperWinner"] = { team1Id, team2Id };
          gamesInRound.push("hayesUpperWinner");
          continue;
        }

        if (
          team1Id === "Hayes Lower Winner" ||
          team2Id === "Hayes Lower Winner"
        ) {
          games["hayesLowerWinner"] = { team1Id, team2Id };
          gamesInRound.push("hayesLowerWinner");
          continue;
        }
      }

      games[gameId] = { team1Id, team2Id };
      gamesInRound.push(gameId);
    }

    bracket[roundIndex] = gamesInRound;
  }

  // Handle third place game for single elimination
  const isSingle = bracketType === "single" || bracketType === "singleHayes";
  if (bracketLevel === "upper" && isSingle) {
    const thirdPlaceGameId = "thirdPlace";
    games[thirdPlaceGameId] = { team1Id: "TBD", team2Id: "TBD" };
    bracket[totalRounds] = [thirdPlaceGameId];
  }

  // Handle grand finals for double elimination
  const isDouble = bracketType === "double" || bracketType === "doubleHayes";
  if (bracketLevel === "upper" && isDouble) {
    const finalGameId = "grandFinals";
    const resetGameId = "grandFinalsReset";

    games[finalGameId] = { team1Id: "TBD", team2Id: "TBD" };
    games[resetGameId] = { team1Id: "TBD", team2Id: "TBD" };

    bracket[totalRounds] = [finalGameId];
    bracket[totalRounds + 1] = [resetGameId];
  }

  return {
    upperBracket: bracket,
    upperBracketGames: games,
  };
};

export default generateUpperBracket;
